import Cookies from "js-cookie"

import {
  store,
  deleteUserAccountInfo,
  clearSystemSettings,
  clearWalletDetails,
  clearSmsBalance,
  deleteContractDeactivationStatus
} from "@redux"
import { userLogoutRefreshToken } from "services"

const logout = ({ notifyServer = true } = {}) => {
  if (notifyServer && localStorage.getItem("rt")) {
    userLogoutRefreshToken().catch(() => {})
  }

  Cookies.remove("token", { path: "/" })

  localStorage.removeItem("at")
  localStorage.removeItem("rt")

  store.dispatch(deleteUserAccountInfo())
  store.dispatch(clearSystemSettings())
  store.dispatch(clearWalletDetails())
  store.dispatch(clearSmsBalance())
  store.dispatch(deleteContractDeactivationStatus())
}

export default logout
